module.exports = __webpack_public_path__ + "static/media/meelis.25ba95dc.jpg";